import styled from 'styled-components';
import Headline from 'common/components/TouchpointEditor/components/TouchpointNodes/Headline';
import { mediaMaxWidth } from 'common/styles/breakpoints';

export default styled(Headline)`
    padding: 2.5rem 4rem;
    ${mediaMaxWidth.medium`
        padding: 2rem 0rem;
    `}
`;
